import { type SVGProps, useId } from "react";

export function SupportIcon(props: SVGProps<SVGSVGElement>) {
	const titleId = useId();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			strokeWidth={1.5}
			role="img"
			aria-labelledby={titleId}
			{...props}
		>
			<title id={titleId}>Support</title>
			<path
				d="M2 7.3335H4C4.35362 7.3335 4.69276 7.47397 4.94281 7.72402C5.19286 7.97407 5.33333 8.31321 5.33333 8.66683V10.6668C5.33333 11.0205 5.19286 11.3596 4.94281 11.6096C4.69276 11.8597 4.35362 12.0002 4 12.0002H3.33333C2.97971 12.0002 2.64057 11.8597 2.39052 11.6096C2.14048 11.3596 2 11.0205 2 10.6668V7.3335ZM2 7.3335C2 6.54556 2.15519 5.76535 2.45672 5.0374C2.75825 4.30944 3.20021 3.64801 3.75736 3.09086C4.31451 2.5337 4.97595 2.09175 5.7039 1.79022C6.43185 1.48869 7.21207 1.3335 8 1.3335C8.78793 1.3335 9.56815 1.48869 10.2961 1.79022C11.0241 2.09175 11.6855 2.5337 12.2426 3.09086C12.7998 3.64801 13.2417 4.30944 13.5433 5.0374C13.8448 5.76535 14 6.54556 14 7.3335M14 7.3335V10.6668M14 7.3335H12C11.6464 7.3335 11.3072 7.47397 11.0572 7.72402C10.8071 7.97407 10.6667 8.31321 10.6667 8.66683V10.6668C10.6667 11.0205 10.8071 11.3596 11.0572 11.6096C11.3072 11.8597 11.6464 12.0002 12 12.0002H12.6667C13.0203 12.0002 13.3594 11.8597 13.6095 11.6096C13.8595 11.3596 14 11.0205 14 10.6668M14 10.6668V12.0002C14 12.7074 13.719 13.3857 13.219 13.8858C12.7189 14.3859 12.0406 14.6668 11.3333 14.6668H8"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
